import { userLanguage, ValidLanguages } from '$translations/index';
import { ErrorMessageEn, ErrorMessageEs } from '../../../../constants/alerts';
import { errorHandler } from '../../../utils';
import {
  CompanyBuilder,
  AddNewPositionNameInput,
  AddNewPositionNameOutput,
} from '../companies.types';

export const addNewPositionName = (builder: CompanyBuilder) =>
  builder.mutation<AddNewPositionNameOutput, AddNewPositionNameInput>({
    query: ({ title, deprecated }) => ({
      url: `/job-positions`,
      method: 'POST',
      body: { title, deprecated },
    }),
    transformErrorResponse: (error) => {
      errorHandler(
        '[AddNewPosition]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.AddNewPositionError
          : ErrorMessageEn.AddNewPositionError,
        error,
        true
      );
    },
    invalidatesTags: () => [{ type: 'Company' }],
  });
